import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const ThreeCardsSection = () => {
  const [hovered, setHovered] = useState(null);

  const imgStyle = (index) => ({
    height: "250px",
    width: "100%",
    objectFit: "cover",
    transition: "transform 0.5s ease",
    transform: hovered === index ? "scale(1.1)" : "scale(1)",
  });

  return (
    <section style={{ backgroundColor: "#f4f8f6", padding: "60px 0" }}>
      <Container>
        <Row className="justify-content-center">

          {/* Card 1 */}
          <Col md={4} sm={12} className="mb-4 d-flex">
            <Card
              className="w-100 border-0"
              style={{ borderRadius: "15px", overflow: "hidden" }}
              onMouseEnter={() => setHovered(1)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{ overflow: "hidden" }}>
                <Card.Img
                  src="https://cms.groupeditors.com/img/ghnw20150817-112916-561.jpg"
                  style={imgStyle(1)}
                />
              </div>

              <Card.Body
                className="text-center text-white d-flex flex-column"
                style={{ backgroundColor: "#87CEEB" }}
              >
                <Card.Title className="fw-bold">
                  Healthy and Fresh Fruits
                </Card.Title>

                <Card.Text className="flex-grow-1">
                  Explore our collection of hand-picked, fresh fruits to add
                  healthy nutrition to your diet.
                </Card.Text>

                {/* <Button
                  variant="success"
                  className="px-4 align-self-center"
                >
                  Shop Now
                </Button> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Card 2 */}
          <Col md={4} sm={12} className="mb-4 d-flex">
            <Card
              className="w-100 border-0"
              style={{ borderRadius: "15px", overflow: "hidden" }}
              onMouseEnter={() => setHovered(2)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{ overflow: "hidden" }}>
                <Card.Img
                  src="https://img.freepik.com/premium-photo/vegetable-image_573563-2661.jpg"
                  style={imgStyle(2)}
                />
              </div>

              <Card.Body
                className="text-center text-white d-flex flex-column"
                style={{ backgroundColor: "#FFB6C1" }}
              >
                <Card.Title className="fw-bold">
                  Fresh and Good Vegetables
                </Card.Title>

                <Card.Text className="flex-grow-1">
                  Get your hands on fresh and organic vegetables, perfect for a
                  healthy meal.
                </Card.Text>

                {/* <Button
                  variant="danger"
                  className="px-4 align-self-center " 
                >
                  Shop Now
                </Button> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Card 3 */}
          <Col md={4} sm={12} className="mb-4 d-flex">
            <Card
              className="w-100 border-0"
              style={{ borderRadius: "15px", overflow: "hidden" }}
              onMouseEnter={() => setHovered(3)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{ overflow: "hidden" }}>
                <Card.Img
                  src="https://st5.depositphotos.com/1063437/71867/i/450/depositphotos_718671612-stock-photo-poznan-pol-jul-2019-dove.jpg"
                  style={imgStyle(3)}
                />
              </div>

              <Card.Body
                className="text-center text-white d-flex flex-column"
                style={{ backgroundColor: "#D8BFD8" }}
              >
                <Card.Title className="fw-bold">
                  Personal Care
                </Card.Title>

                <Card.Text className="flex-grow-1">
                  Personal care is essential for maintaining your overall
                  well-being and confidence.
                </Card.Text>

                {/* <Button
                  className="px-4 align-self-center"
                  style={{
                    backgroundColor: "#db4db8",
                    borderColor: "#db4db8",
                  }}
                >
                  Shop Now
                </Button> */}
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default ThreeCardsSection;
